import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { SettingsCard } from '../../components/composed';
import { useAuth } from '../../contexts/AuthContext';

// Date formatting utility function
const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};

// Date time formatting utility function
const formatDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  try {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (error) {
    console.error('Error formatting date:', error);
    return 'Invalid Date';
  }
};

const UserSettings = () => {
  const { user, loading } = useAuth();

  if (loading || !user) {
    return (
      <SettingsCard title="User Settings">
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <Typography variant="body2" color="text.secondary">
            Loading user information...
          </Typography>
        </Box>
      </SettingsCard>
    );
  }

  return (
    <SettingsCard title="User Settings">
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Username */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Username
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {user.username || 'N/A'}
              </Typography>
            </Box>

            {/* First Name */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                First Name
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {user.first_name || 'N/A'}
              </Typography>
            </Box>

            {/* Last Name */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Last Name
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {user.last_name || 'N/A'}
              </Typography>
            </Box>

            {/* Email */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Email
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {user.email || 'N/A'}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Is Active */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Active Status
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {user.is_active ? 'Active' : 'Inactive'}
              </Typography>
            </Box>

            {/* Date Joined */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Date Joined
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {formatDate(user.date_joined)}
              </Typography>
            </Box>

            {/* Is Staff */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Staff Status
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {user.is_staff ? 'Yes' : 'No'}
              </Typography>
            </Box>

            {/* Updated At */}
            <Box>
              <Typography variant="body2" color="text.secondary" gutterBottom>
                Last Updated
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                {formatDateTime(user.updated_at)}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default UserSettings;
